import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class CheckMaxFreespinsReached extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        let maxReached = false;

        // Record triggered free spins but didn't award any more spins, so it must have been capped
        if (record instanceof FreespinRecord) {
            for (const result of record.results) {
                if (result instanceof FreespinWinResult && result.freespinsWon === 0) {
                    maxReached = true;
                }
            }
        }

        return maxReached ? Exit.True : Exit.False;
    }
}
